import qs from 'query-string';
import { getPageProps } from '@kibt/krn-utils';
import { getAddressApiRes } from '@/common/api/address/addressQueryV3Cache';
import { getEnv, getKrnDomain } from '../api';
import queryString from 'query-string';
import { abPromise } from '@/store/useAbStore';

export async function goAddAddressWhenNoAddress(url: string) {
    // address/add ,避免当前页就是add页，但由于getAddressApiRes未正常获取信息，不跳转
    if (!url.includes('/order-confirm') || location.pathname.includes('/address/add')) return url;
    const { query } = qs.parseUrl(url);

    // 从地址添加页跳到提单页不作判断
    // 需要catch住，万一接口挂了，不能影响跳转
    const res = await getAddressApiRes().catch(e => e);
    if (res?.[0]?.data?.length === 0) {
        // 无地址，直接去添加地址
        const krnUrl = qs.stringify({
            bundleId: 'EcommAddress',
            componentName: 'EcommAddress',
            env: getEnv(),
        });
        await localStorage.setItem('goAddAddressWhenNoAddressTempQuery', JSON.stringify(query));
        return qs.stringifyUrl({
            url: `${getKrnDomain()}/address/add`,
            query: {
                krnFollowParams: 1,
                env: getEnv(),
                ...{
                    ...query,
                    // 覆盖原来的Url componentName值，否则ios跳转会失败
                    componentName: null,
                },
                // extParams: JSON.stringify(getExtParams()),
                goOrderConfirmWhenDone: '1',
                showAddressBenefit: true,
                type: 'AddNew',
                hyId: 'kibt-fe-shop-c-krn',
                __launch_options__: JSON.stringify({
                    topBarPosition: 'fixed',
                }),
                redirectUrl: krnUrl,
                isDefault: 'TRUE',
            },
        });
    }

    return url;
}

export async function parseAddressUrl(url: string) {
    const _url = queryString.parseUrl(url).url;
    if (!_url.includes('address') || _url.includes('address-half')) return url;
    const ab = await abPromise;
    const interactiveOptimization = ab?.interactive_optimization || false;

    const { query } = qs.parseUrl(url);
    const krnUrl = qs.stringify({
        bundleId: 'EcommAddress',
        componentName: 'EcommAddress',
        env: getEnv(),
    });
    const isGoAddPage = url.includes('address/add');
    return qs.stringifyUrl({
        url: isGoAddPage ? `${getKrnDomain()}/krn-web/address/add` : `${getKrnDomain()}/krn-web/address`,
        query: {
            krnFollowParams: 1,
            env: getEnv(),
            ...query,
            // extParams: JSON.stringify(getExtParams()),
            fromBundle: getPageProps().bundleId,
            source: getPageProps().bundleId,
            ...(isGoAddPage
                ? {
                      type: query.id ? 'update' : 'AddNew',
                  }
                : {}),
            initialRouteName: isGoAddPage ? (interactiveOptimization ? 'AddressAddV2' : 'AddressAdd') : 'AddressHome',
            hyId: 'kibt-fe-shop-c-krn',
            __launch_options__: JSON.stringify({
                topBarPosition: 'fixed',
            }),
            redirectUrl: krnUrl,
        },
    });
}
